module.exports = __webpack_public_path__ + "img/F_02.19751d1c.gif";